/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { LicenseStatusTypes } from './LicenseStatusTypes';
import {
    LicenseStatusTypesFromJSON,
    LicenseStatusTypesFromJSONTyped,
    LicenseStatusTypesToJSON,
} from './LicenseStatusTypes';

/**
 * 
 * @export
 * @interface LicenseStatusDto
 */
export interface LicenseStatusDto {
    /**
     * 
     * @type {LicenseStatusTypes}
     * @memberof LicenseStatusDto
     */
    licenseStatus?: LicenseStatusTypes;
    /**
     * 
     * @type {string}
     * @memberof LicenseStatusDto
     */
    expirationDate?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LicenseStatusDto
     */
    $type?: LicenseStatusDtoTypeEnum;
}


/**
 * @export
 */
export const LicenseStatusDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedLicenseComponentDtoLicenseStatusDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.LicenseComponent.Dto.LicenseStatusDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type LicenseStatusDtoTypeEnum = typeof LicenseStatusDtoTypeEnum[keyof typeof LicenseStatusDtoTypeEnum];



/**
 * Check if a given object implements the LicenseStatusDto interface.
 */
export function instanceOfLicenseStatusDto(value?: unknown): value is LicenseStatusDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(LicenseStatusDtoTypeEnum)[0];
}

export function LicenseStatusDtoFromJSON(json: any): LicenseStatusDto {
    return LicenseStatusDtoFromJSONTyped(json, false);
}

export function LicenseStatusDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): LicenseStatusDto {
    if (json == null) {
        return json;
    }
    return {
        
        'licenseStatus': json['licenseStatus'] == null ? undefined : LicenseStatusTypesFromJSON(json['licenseStatus']),
        'expirationDate': json['expirationDate'] == null ? undefined : json['expirationDate'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function LicenseStatusDtoToJSON(value?: LicenseStatusDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'licenseStatus': LicenseStatusTypesToJSON(value['licenseStatus']),
        'expirationDate': value['expirationDate'],
        '$type': value['$type'],
    });
}

